import type { PreorderStatus } from "@/lib/products";
import { getStatusTone } from "@/lib/products";

export function StatusBadge({
  status,
  label
}: {
  status: PreorderStatus | string;
  /** Teks yang ditampilkan; default = status. Warna tetap mengikuti `status`. */
  label?: string;
}) {
  return (
    <span
      className={`inline-flex h-6 items-center rounded-full px-2.5 text-[10px] font-bold tracking-normal ${
        getStatusTone(status)
      }`}
    >
      {label ?? status}
    </span>
  );
}
